import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import UserSlice from "./authSlice";
import authSlice from "./authSlice";
import businessSidebarTitlesSlice from "./businessSidebarTitlesSlice";
import BussinessListSlice from "./BussinessListSlice";
import bussinessSlice from "./bussinessSlice";
import NavbarBussinessSlice from "./NavbarBussinessSlice";
import NavbarUserSlice from "./NavbarUserSlice";
import uploadSlice from "./uploadSlice";

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "navbarUser",
    "BussinessList",
    "navbarBussiness",
    "userSlice",
    "authSlice",
    "bussinessSlice",
    "upload",
    "businessSidebar",
  ], // List the slices you want to persist
};

// Combine reducers
const rootReducer = combineReducers({
  navbarUser: NavbarUserSlice,
  BussinessList: BussinessListSlice,
  navbarBussiness: NavbarBussinessSlice,
  userSlice: UserSlice,
  authSlice: authSlice,
  bussinessSlice: bussinessSlice,
  upload: uploadSlice,
  businessSidebar: businessSidebarTitlesSlice,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Create a persistor
export const persistor = persistStore(store);
